// @ts-nocheck



import CommonApi from './../commonApi';
import {
  convertFromKopToRub,
  convertFromMToKm,
  convertFromSecondToHour } from
'../pure/unitConversions';

export const convertDataFromServer = (fuelsAndOilsAct) => ({
  ...fuelsAndOilsAct,
  sum: convertFromKopToRub(fuelsAndOilsAct.sum),
  kilometrage: convertFromMToKm(fuelsAndOilsAct.kilometrage),
  workHours: convertFromSecondToHour(fuelsAndOilsAct.workHours),
  equipmentWorkHours: convertFromSecondToHour(
    fuelsAndOilsAct.equipmentWorkHours
  )
});

const fuelsAndOilsAct = new CommonApi(
  'fuelsAndOilsAct',
  'акт списания ГСМ',
  undefined,
  convertDataFromServer
);

export default {
  deleteFuelsAndOilsAct: fuelsAndOilsAct.delete,
  addFuelsAndOilsAct: fuelsAndOilsAct.add,
  updateFuelsAndOilsAct: fuelsAndOilsAct.update,
  getFuelsAndOilsAct: fuelsAndOilsAct.get,
  fetchFuelsAndOilsAct: fuelsAndOilsAct.fetch
};
